module.exports = __webpack_public_path__ + "static/media/right-bg.f9842723.png";